var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TopBar',{staticClass:"desktop-only"}),_vm._v(" "),_c('div',{attrs:{"id":"layout"}},[_c('AppHeader'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('BottomNavigation'),_vm._v(" "),_c('CartSidebar'),_vm._v(" "),_c('LoginModal')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }